export const ethnicityOptions = [
  { value: 'south-america', label: 'South America' },
  { value: 'arab-maghreb', label: 'Arab Maghreb' },
  { value: 'black-africa', label: 'Black Africa' },
  { value: 'eastern-europa', label: 'Eastern Europa' },
  { value: 'mediterranea-europa', label: 'Mediterranea Europa' },
  { value: 'white', label: 'White' },
  { value: 'metis', label: 'Metis' },
  { value: 'asian', label: 'Asian' },
  { value: 'indian', label: 'Indian' },
]

export const statusOptions = [
  { value: 'private, escort, massage', label: 'private, escort, massage' },
  {
    value:
      'maison privee, bars et clubs prive, salons de massage, hotels coquins, saunas prives, clubs echangistes, event',
    label:
      'maison privee, bars et clubs prive, salons de massage, hotels coquins, saunas prives, clubs echangistes, event',
  },
  { value: 'libertins ou visiteur', label: 'libertins ou visiteur' },
]

export const orientationOptions = [
  { value: 'heterosexual', label: 'Heterosexual' },
  { value: 'homosexual', label: 'Homosexual' },
  { value: 'bisexual', label: 'Bisexual' },
]

export const genderOptions = [
  { value: 'man', label: 'Man' },
  { value: 'woman', label: 'Woman' },
  { value: 'transgender', label: 'Transgender' },
  { value: 'couple', label: 'Couple' },
]

export const eyesOptions = [
  { value: 'brown', label: 'Brown' },
  { value: 'blue', label: 'Blue' },
  { value: 'green', label: 'Green' },
  { value: 'grey', label: 'Grey' },
]

export const massageOnlyOptions = [
  { value: 'yes-massage-only', label: 'Yes, only massage' },
  { value: 'no-other-services', label: 'No, I offer other services' },
]

export const hairOptions = [
  { value: 'black', label: 'Black' },
  { value: 'brown', label: 'Brown' },
  { value: 'chesnut', label: 'Chesnut' },
  { value: 'blonde', label: 'Blonde' },
  { value: 'red', label: 'Red' },
  { value: 'grey', label: 'Grey' },
  { value: 'white', label: 'White' },
]

export const breastsOptions = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'medium-natural', label: 'Medium (natural)' },
  { value: 'big', label: 'Big' },
  { value: 'big-natural', label: 'Big (natural)' },
  { value: 'huge', label: 'Huge' },

  { value: 'huge-natural', label: 'Huge (natural)' },
]

export const intimateOptions = [
  { value: 'natural', label: 'Natural' },
  { value: 'simple-shave', label: 'Simple Shave' },
  { value: 'triangle', label: 'Triangle' },
  { value: 'rectangle', label: 'Rectangle' },
  { value: 'full-shave', label: 'Full Shave' },
]

export const nationalitiesOptions = [
  { value: 'afghan', label: 'Afghan' },
  { value: 'albanian', label: 'Albanais' },
  { value: 'algerian', label: 'Algérien' },
  { value: 'american', label: 'Américain' },
  { value: 'andorran', label: 'Andorran' },
  { value: 'angolan', label: 'Angolais' },
  { value: 'antiguans', label: 'Antiguais' },
  { value: 'argentine', label: 'Argentin' },
  { value: 'armenian', label: 'Arménien' },
  { value: 'australian', label: 'Australien' },
  { value: 'austrian', label: 'Autrichien' },
  { value: 'azerbaijani', label: 'Azerbaïdjanais' },
  { value: 'bahamian', label: 'Bahaméen' },
  { value: 'bahraini', label: 'Bahreïni' },
  { value: 'bangladeshi', label: 'Bangladais' },
  { value: 'barbadian', label: 'Barbadien' },
  { value: 'belarusian', label: 'Biélorusse' },
  { value: 'belgian', label: 'Belge' },
  { value: 'belizean', label: 'Bélizien' },
  { value: 'beninese', label: 'Béninois' },
  { value: 'bhutanese', label: 'Bhoutanais' },
  { value: 'bolivian', label: 'Bolivien' },
  { value: 'bosnian', label: 'Bosnien' },
  { value: 'brazilian', label: 'Brésilien' },
  { value: 'british', label: 'Britannique' },
  { value: 'bruneian', label: 'Brunéien' },
  { value: 'bulgarian', label: 'Bulgare' },
  { value: 'burkinabe', label: 'Burkinabé' },
  { value: 'burmese', label: 'Birman' },
  { value: 'burundian', label: 'Burundais' },
  { value: 'cambodian', label: 'Cambodgien' },
  { value: 'cameroonian', label: 'Camerounais' },
  { value: 'canadian', label: 'Canadien' },
  { value: 'cape verdean', label: 'Cap-verdien' },
  { value: 'central african', label: 'Centrafricain' },
  { value: 'chadian', label: 'Tchadien' },
  { value: 'chilean', label: 'Chilien' },
  { value: 'chinese', label: 'Chinois' },
  { value: 'colombian', label: 'Colombien' },
  { value: 'comoran', label: 'Comorien' },
  { value: 'congolese', label: 'Congolais' },
  { value: 'costa rican', label: 'Costaricain' },
  { value: 'croatian', label: 'Croate' },
  { value: 'cuban', label: 'Cubain' },
  { value: 'cypriot', label: 'Chypriote' },
  { value: 'czech', label: 'Tchèque' },
  { value: 'danish', label: 'Danois' },
  { value: 'djiboutian', label: 'Djiboutien' },
  { value: 'dominican', label: 'Dominicain' },
  { value: 'dutch', label: 'Néerlandais' },
  { value: 'east timorese', label: 'Timorais oriental' },
  { value: 'ecuadorean', label: 'Équatorien' },
  { value: 'egyptian', label: 'Égyptien' },
  { value: 'emirati', label: 'Émirati' },
  { value: 'english', label: 'Anglais' },
  { value: 'equatorial guinean', label: 'Équatoguinéen' },
  { value: 'eritrean', label: 'Érythréen' },
  { value: 'estonian', label: 'Estonien' },
  { value: 'ethiopian', label: 'Éthiopien' },
  { value: 'fijian', label: 'Fidjien' },
  { value: 'filipino', label: 'Philippin' },
  { value: 'finnish', label: 'Finlandais' },
  { value: 'french', label: 'Français' },
  { value: 'gabonese', label: 'Gabonais' },
  { value: 'gambian', label: 'Gambien' },
  { value: 'georgian', label: 'Géorgien' },
  { value: 'german', label: 'Allemand' },
  { value: 'ghanaian', label: 'Ghanéen' },
  { value: 'greek', label: 'Grec' },
  { value: 'grenadian', label: 'Grenadien' },
  { value: 'guatemalan', label: 'Guatémaltèque' },
  { value: 'guinea-bissauan', label: 'Bissau-Guinéen' },
  { value: 'guinean', label: 'Guinéen' },
  { value: 'guyanese', label: 'Guyanien' },
  { value: 'haitian', label: 'Haïtien' },
  { value: 'herzegovinian', label: 'Herzégovinien' },
  { value: 'honduran', label: 'Hondurien' },
  { value: 'hungarian', label: 'Hongrois' },
  { value: 'i-kiribati', label: 'Kiribatien' },
  { value: 'icelander', label: 'Islandais' },
  { value: 'indian', label: 'Indien' },
  { value: 'indonesian', label: 'Indonésien' },
  { value: 'iranian', label: 'Iranien' },
  { value: 'iraqi', label: 'Irakien' },
  { value: 'irish', label: 'Irlandais' },
  { value: 'israeli', label: 'Israélien' },
  { value: 'italian', label: 'Italien' },
  { value: 'ivorian', label: 'Ivoirien' },
  { value: 'jamaican', label: 'Jamaïcain' },
  { value: 'japanese', label: 'Japonais' },
  { value: 'jordanian', label: 'Jordanien' },
  { value: 'kazakhstani', label: 'Kazakh' },
  { value: 'kenyan', label: 'Kényan' },
  { value: 'kittian and nevisian', label: 'Kittitien et Névicien' },
  { value: 'kuwaiti', label: 'Koweïtien' },
  { value: 'kyrgyz', label: 'Kirghize' },
  { value: 'laotian', label: 'Laotien' },
  { value: 'latvian', label: 'Letton' },
  { value: 'lebanese', label: 'Libanais' },
  { value: 'liberian', label: 'Libérien' },
  { value: 'libyan', label: 'Libyen' },
  { value: 'liechtensteiner', label: 'Liechtensteinois' },
  { value: 'lithuanian', label: 'Lituanien' },
  { value: 'luxembourger', label: 'Luxembourgeois' },
  { value: 'macedonian', label: 'Macédonien' },
  { value: 'malagasy', label: 'Malgache' },
  { value: 'malawian', label: 'Malawien' },
  { value: 'malaysian', label: 'Malaisien' },
  { value: 'maldivan', label: 'Maldivien' },
  { value: 'malian', label: 'Malien' },
  { value: 'maltese', label: 'Maltais' },
  { value: 'marshallese', label: 'Marshallais' },
  { value: 'mauritanian', label: 'Mauritanien' },
  { value: 'mauritian', label: 'Mauricien' },
  { value: 'mexican', label: 'Mexicain' },
  { value: 'micronesian', label: 'Micronésien' },
  { value: 'moldovan', label: 'Moldave' },
  { value: 'monacan', label: 'Monégasque' },
  { value: 'mongolian', label: 'Mongol' },
  { value: 'montenegrin', label: 'Monténégrin' },
  { value: 'moroccan', label: 'Marocain' },
  { value: 'mosotho', label: 'Mosotho' },
  { value: 'motswana', label: 'Motswana' },
  { value: 'mozambican', label: 'Mozambicain' },
  { value: 'namibian', label: 'Namibien' },
  { value: 'nauruan', label: 'Nauruan' },
  { value: 'nepalese', label: 'Népalais' },
  { value: 'new zealander', label: 'Néo-Zélandais' },
  { value: 'nicaraguan', label: 'Nicaraguayen' },
  { value: 'nigerian', label: 'Nigérian' },
  { value: 'nigerien', label: 'Nigérien' },
  { value: 'north korean', label: 'Nord-Coréen' },
  { value: 'northern irish', label: 'Nord-Irlandais' },
  { value: 'norwegian', label: 'Norvégien' },
  { value: 'omani', label: 'Omanais' },
  { value: 'pakistani', label: 'Pakistanais' },
  { value: 'palauan', label: 'Paluan' },
  { value: 'panamanian', label: 'Panaméen' },
  { value: 'papua new guinean', label: 'Papouasien-Néo-Guinéen' },
  { value: 'paraguayan', label: 'Paraguayen' },
  { value: 'peruvian', label: 'Péruvien' },
  { value: 'polish', label: 'Polonais' },
  { value: 'portuguese', label: 'Portugais' },
  { value: 'qatari', label: 'Qatari' },
  { value: 'romanian', label: 'Roumain' },
  { value: 'russian', label: 'Russe' },
  { value: 'rwandan', label: 'Rwandais' },
  { value: 'saint lucian', label: 'Saint-Lucien' },
  { value: 'salvadoran', label: 'Salvadorien' },
  { value: 'samoan', label: 'Samoan' },
  { value: 'san marinese', label: 'Saint-Marinais' },
  { value: 'sao tomean', label: 'Santoméen' },
  { value: 'saudi', label: 'Saoudien' },
  { value: 'scottish', label: 'Écossais' },
  { value: 'senegalese', label: 'Sénégalais' },
  { value: 'serbian', label: 'Serbe' },
  { value: 'slovak', label: 'Slovaque' },
  { value: 'slovenian', label: 'Slovène' },
  { value: 'somali', label: 'Somalien' },
  { value: 'south-african', label: 'Sud-Africain' },
  { value: 'spanish', label: 'Espagnol' },
  { value: 'sri-lankan', label: 'Sri-Lankais' },
  { value: 'sudanese', label: 'Soudanais' },
  { value: 'swedish', label: 'Suédois' },
  { value: 'swiss', label: 'Suisse' },
  { value: 'syrian', label: 'Syrien' },
  { value: 'taiwanese', label: 'Taïwanais' },
  { value: 'tajik', label: 'Tadjik' },
  { value: 'tanzanian', label: 'Tanzanien' },
  { value: 'thai', label: 'Thaïlandais' },
  { value: 'togolese', label: 'Togolais' },
  { value: 'tunisian', label: 'Tunisien' },
  { value: 'turkish', label: 'Turc' },
  { value: 'turkmen', label: 'Turkmène' },
  { value: 'ugandan', label: 'Ougandais' },
  { value: 'ukrainian', label: 'Ukrainien' },
  { value: 'uruguayan', label: 'Uruguayen' },
  { value: 'uzbek', label: 'Ouzbek' },
  { value: 'venezuelan', label: 'Vénézuélien' },
  { value: 'vietnamese', label: 'Vietnamien' },
  { value: 'welsh', label: 'Gallois' },
  { value: 'yemeni', label: 'Yéménite' },
  { value: 'zambian', label: 'Zambien' },
  { value: 'zimbabwean', label: 'Zimbabwéen' },
]
